import React, { useState } from "react";
import { useTheme } from "../hooks/useTheme";
import { Alert, Snackbar } from "@mui/material";
import { disableVehicleLocationStatusColorCode } from "../../utils/statusColorCode";
import DisabledVehicleLocationRequestDetails from "../../pages/carrental/reservations/DisabledVehicleLocationRequestDetails";
import moment from "moment";
import useGeneral from "../hooks/useGeneral";

type DisabledVehicleLocationListProps = {
    disabledVehicleLocationData: any[],
    setShareLocationRefresh: (value: boolean) => void;
    isCompletedOrCancelled: boolean;
    setPleaseWait: (value: boolean) => void;
}

const DisabledVehicleLocationList = ({
    disabledVehicleLocationData,
    setShareLocationRefresh,
    isCompletedOrCancelled,
    setPleaseWait
}: DisabledVehicleLocationListProps) => {
    const { themeStyles } = useTheme();
    const { dateFormat }: any = useGeneral();
    const [opneDisabledVehicleLocationDetasilsPopup, setOpneDisabledVehicleLocationDetasilsPopup] = useState<boolean>(false);
    const [disableVehicleLocationDetails, setDisableVehicleLocationDetails] = useState<any>({});
    const [showCopyPopup, setShowCopyPopup] = useState<boolean>(false);

    return (
        <>
            <table className="min-w-full table-auto">
                <tbody className="text-left">
                    <tr className={`border-b ${themeStyles.main.borderColor}`}>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Vehicle Name</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Email</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Phone Number</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Status</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Link</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Is Responded</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created At</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                    </tr>

                    {
                        disabledVehicleLocationData?.map((item: any, index: number) => {
                            const statusColor = disableVehicleLocationStatusColorCode?.find((color: any) => color?.label === item?.status?.trim()?.toLowerCase()) || {
                                colorBg: "#000000",
                                colorText: "#000000"
                            };

                            return (
                                <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                                    <td
                                        className={`px-4 py-2 whitespace-nowrap text-xs font-medium text-blue-500 underline cursor-pointer ${themeStyles.main.textHeadingColor}`}
                                        onClick={() => {
                                            setOpneDisabledVehicleLocationDetasilsPopup(true);
                                            setDisableVehicleLocationDetails(item);
                                        }}
                                    >
                                        {item?.id}
                                    </td>

                                    <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                        <span
                                            className="text-blue-500 cursor-pointer underline"
                                            onClick={() => {
                                                setOpneDisabledVehicleLocationDetasilsPopup(true);
                                                setDisableVehicleLocationDetails(item);
                                            }}
                                        >
                                            {item?.vehicleName}
                                        </span>
                                    </td>

                                    <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                        {item?.email}
                                    </td>

                                    <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                        {item?.phoneNumber}
                                    </td>

                                    <td className="px-4 py-2 whitespace-nowrap text-xs font-medium">
                                        <span className={`px-[10px] py-[2px] rounded-xl border ${themeStyles.main.borderColor} ${statusColor.colorText} ${statusColor.colorBg}`}>
                                            {item?.status}
                                        </span>
                                    </td>

                                    <td className="px-4 py-2 whitespace-nowrap text-xs font-medium text-blue-500 cursor-pointer hover:underline"
                                        onClick={() => {
                                            if (showCopyPopup) {
                                                setShowCopyPopup(false);
                                            }
                                            navigator.clipboard.writeText(item?.link);
                                            setShowCopyPopup(true);
                                            setTimeout(() => setShowCopyPopup(false), 500);
                                        }}
                                    >
                                        Click here to copy
                                    </td>

                                    <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                        {item?.isResponded ? "Yes" : "No"}
                                    </td>

                                    <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                        {item?.createdAt
                                            ? moment(new Date(item.createdAt)).format(dateFormat + " hh:mm a")
                                            : ""}
                                    </td>

                                    <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                        {item?.createdBy}
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>

            <DisabledVehicleLocationRequestDetails
                open={opneDisabledVehicleLocationDetasilsPopup}
                onClose={() => setOpneDisabledVehicleLocationDetasilsPopup(false)}
                isCompletedOrCancelled={isCompletedOrCancelled}
                setPleaseWait={setPleaseWait}
                disableVehicleLocationDetails={disableVehicleLocationDetails}
                refreshTheShareLocationRequest={() => setShareLocationRefresh(true)}
            />

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={showCopyPopup}
                autoHideDuration={1000}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    Link copied
                </Alert>
            </Snackbar>
        </>
    )
}

export default DisabledVehicleLocationList;